import Mask from './mask';

const errorHtml = (message) => `<p class="error"><small>${message}</small></p>`;

function camelToKebab(input) {
  return input.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

const isNull = (val) => !val || val === '';

const EMAIL_REGEX =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const VALIDATIONS = {
  required: (val) => !!val && val !== '',
  email: (val) => isNull(val) || val.match(EMAIL_REGEX),
  minLength: (val, attr) => val && val.length >= Number(attr),
  phone(val) {
    const len = val && val.replace(/\D/g, '').length;
    return !len || len === 10;
  },
};

const VALIDATION_MESSAGES = {
  required: () => 'This field is required',
  email: () => 'That is not a valid email',
  phone: () => 'That is not a valid phone number',
  minLength: (val) => `This field must contain at least ${val} characters`,
};

const INPUT_SELECTORS = 'input, select, textarea';

function clearErrors(container) {
  const input = container.querySelector(INPUT_SELECTORS);
  if (input) input.classList.remove('input--error');

  const errors = container.querySelectorAll('p.error');
  for (var i = 0; i < errors.length; i++) {
    errors[i].parentNode.removeChild(errors[i]);
  }
}

function setGlobalError(message) {
  const container = document.querySelector('.global-errors');
  setError(container, message);
}

function clearGlobalErrors() {
  const container = document.querySelector('.global-errors');
  clearErrors(container);
}

function setError(container, message) {
  const div = document.createElement('div');

  const input = container.querySelector(INPUT_SELECTORS);
  if (input) input.classList.add('input--error');

  div.innerHTML = errorHtml(message);
  container.appendChild(div.firstChild);
}

function validate(container) {
  clearErrors(container);
  const input = container.querySelector(INPUT_SELECTORS);
  if (!input) return;

  // Get the list of validations to apply for this input
  const validations = Object.keys(VALIDATIONS)
    .map((type) => [type, input.getAttribute(`data-${camelToKebab(type)}`)])
    .filter((el) => !!el[1]);

  const failed = validations.find(([key, arg]) => !VALIDATIONS[key](input.value, arg));

  if (failed) {
    setError(container, VALIDATION_MESSAGES[failed[0]](failed[1]));
  }
}

window.addEventListener('DOMContentLoaded', (event) => {
  const containers = document.querySelectorAll('.input-container');
  for (var i = 0; i < containers.length; i++) {
    const container = containers[i];

    const label = container.querySelector('.input-label');
    const input = container.querySelector(INPUT_SELECTORS);
    if (!input) continue;

    if (input.getAttribute('data-phone')) {
      try {
        new Mask(input, { init: true, mask: '999-999-9999' });
      } catch (e) {}
    }

    input.addEventListener('focus', (evt) => {
      label.classList.add('input-label--focused');
    });

    input.addEventListener('input', (evt) => {
      if (evt.target.getAttribute('data-touched')) {
        validate(container);
      }
    });

    input.addEventListener('blur', (evt) => {
      if (!evt.target.value) {
        label.classList.remove('input-label--focused');
      }
      evt.target.setAttribute('data-touched', true);
      validate(container);
    });
  }
});

export { clearErrors, setError, validate, setGlobalError, clearGlobalErrors };
